
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/orders/[orderId]",
      function () {
        return require("private-next-pages/account/orders/[orderId]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/orders/[orderId]"])
      });
    }
  